const state = function () {
  return {
    globalLocale: 'en',
    localsStore: new Map()
  }
}

const mutations = {
  setGlobalLocale (state, locale) {
    state.localsStore = new Map()
    state.globalLocale = locale
  },
  setLocale (state, key, locale) {
    state.localsStore[key] = locale
  }
}

const getters = {
  globalLocale (state) {
    return state.globalLocale
  },
  getLocale (state) {
    return function (key) {
      return state.localsStore[key] || state.globalLocale
    }
  }
}
export default {
  state,
  mutations,
  getters,
  namespaced: true
}



// WEBPACK FOOTER //
// ./src/store/modules/localization/index.js